import { render } from "./spinner-jvm.vue?vue&type=template&id=05ea1b7a"
import script from "./spinner-jvm.vue?vue&type=script&lang=js"
export * from "./spinner-jvm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__